import { useEffect, useState } from 'react'
import moment from 'moment'
import { AppTooltip } from 'shared/ui/AppTooltip'
import { useGetProjectTimeZoneQuery } from 'core/api/ProjectTimeZoneApi'

const CurrentDate = () => {
  const lang = process.env.REACT_APP_LANG || 'ru'
  const { data: projectTimeZone } = useGetProjectTimeZoneQuery(null)
  const [date, setDate] = useState('')
  moment.locale(lang)

  useEffect(() => {
    if (!projectTimeZone) return
    const serverTime = moment.parseZone(projectTimeZone.serverTime)
    const tick = () =>
      setDate(
        serverTime
          .clone()
          .add(Date.now() - projectTimeZone.receivedAt, 'milliseconds')
          .format('DD.MM.YYYY dd LT'),
      )
    tick()
    const interval = setInterval(tick, 1000)
    return () => clearInterval(interval)
  }, [projectTimeZone])

  if (!projectTimeZone) return null

  return (
    <AppTooltip
      tooltipContent={`Время сервера отличается от UTC на ${projectTimeZone.timeZone.replace(
        'UTC',
        '',
      )} ч.`}
      contentClassName="tooltipContent-compact"
    >
      <span>{date}</span>
    </AppTooltip>
  )
}

export default CurrentDate
